module.exports = {
    "Leave the Chat": "Quitter le Chat",
    "This will disconnect all participants and end the chat. This cannot be undone - are you sure?": "!!! ATTENTION !!!\n----------------\nTous les participants seront déconnectés et cela mettra fin au Live Chat. \nCette action est irréversible. \nEtes-vous sûr de vouloir mettre fin au Live Chat ?",
    "Are you sure you want to leave the chat?": "Etes-vous sûr(e) de vouloir quitter le Live Chat ?",
    "The chat has been closed": "Le Live Chat a été fermé",
    "Terminate the chat": "Mettre fin au Chat",
    "Post a message to everyone": "Envoyer une notification globale",
    "Sorry, an error occurred.": "Désolé, une erreur s'est produite.",
    "Sorry, you must be logged in to access this Live Chat.%{login_message}": "Désolé, vous devez tout d'abord être connecté pour rejoindre le Live Chat.%{login_message}",
    "Chat initialization failed. Service unavailable.": "L'initialisation du Live Chat a echoué. Service indisponible.",
    "Click <a href=\"%{login_url}\">here</a> to log in.": "Cliquez <a href=\"%{login_url}\">ici</a> pour vous connecter.",
    "NOTIFICATION": "NOTIFICATION",
    "Close notification": "Fermer la notification",
    "Click to reload Live Chat": "Cliquez pour recharger le Live Chat",
    "All Discussions": "Toutes les Discussions",
    "Filter by Topic": "Filtrer par Thème",
    "Followed": "Suivie",
    "Followed_plural": "Suivies",
    "Search…": "Recherchez…",
    "Unanswered": "En attente de réponse",
    "Unread": "Non lue",
    "Unread_plural": "Non lues",
    "Your questions": "Vos questions",
    "Live Chat": "Live Chat",
    "Off": "Off",
    "On": "On",
    "Settings": "Paramètres",
    "Press \"Enter\" to send": "\"⏎\" pour envoyer",
    "Sound notifications": "Sons",
    "Order by activity": "Trier par activité",
    "Cancel": "Annuler",
    "Send my alert": "Envoyer la notification",
    "This will be shown to all people online": "Cette notification sera envoyée à toutes les personnes connectées",
    "Type your full message here...": "Tapez votre message ici...",
    "hr": "h",
    "just now": "à l'instant",
    "min": "mn",
    "Delete": "Supprimer",
    "Add your message here…": "Ecrivez votre message ici…",
    "Post": "Poster",
    "in topic %{topic}": "sur le thème %{topic}",
    "Optional: additional details can be added below": "Facultatif: les détails additionnels peuvent être précisés ci-dessous",
    "Ask a new question": "Poser une question",
    "Ensure that your question has not already been asked by someone else.": "Assurez-vous que votre question n'a pas déjà été posée par quelqu'un d'autre.",
    "Ask your question here": "Poser une nouvelle question",
    "%{max_chars} characters max. (%{num_chars} left)": "%{max_chars} caractères max. (%{num_chars} restant)",
    "Add additional information to your question here…": "Ecrivez ici l'éventuel complément d'information relative à votre question…",
    "Post my question": "Poser ma question",
    "Write your question here…": "Ecrivez votre question ici…",
    "You need to provide a question title between 20 and 120 characters.": "Vous devez indiquer un titre de question de 20 à 120 caractères.",
    "Select…": "Sélectionnez…",
    "Please choose a category for your question": "Choisissez le thème de votre question",
    "created at": "créée à",
    "updated at": "mise à jour à",
    "Follow": "Suivre",
    "Unfollow": "Ne plus suivre",
    "%{num_people} people on the chat": "%{num_people} personne connectée",
    "%{num_people} people on the chat_plural": "%{num_people} personnes connectées",
    "%{num_insiders} Insiders Online": "%{num_insiders} Ambassadeur connecté",
    "%{num_insiders} Insiders Online_plural": "%{num_insiders} Ambassadeurs connectés",
    "from %{start_time} to %{end_time}": "de %{start_time} à %{end_time}",
    "Welcome %{user_firstname}": "Bienvenue %{user_firstname}",
    "OR": "OU",
    "Say hello, introduce yourself as an Insider": "Dites bonjour, et présentez-vous en tant qu'Ambassadeur",
    "Access current discussions": "Accédez aux discussions",
    "Sufficient information about the role and working there": "Avoir accès à suffisamment d’informations quant au poste et au quotidien dans l’entreprise",
    "A clear recruitment process": "Un process de recrutement clair",
    "Quality interviews/assessments": "Des entretiens et évaluations de qualité",
    "Being able to engage with employees": "Avoir la possibilité de dialoguer avec des ambassadeurs en poste",
    "Keeping me updated on my application status": "Me tenir informé(e) sur le statut de ma candidature",
    "An efficient application system": "Un système efficace pour postuler",
    "Giving me feedback on my application": "Me donner des retours qualitatifs quant à ma candidature",
    "Other": "Autre",
    "Close": "Fermer",
    "Please specify…": "Merci de préciser…",
    "Which 3 factors are most important to ensure a good experience when you apply to a company?": "Quels sont les 3 facteurs les plus importants pour vous assurer une bonne expérience en ligne lorsque vous postulez auprès d’une entreprise ?",
    "Send and enter chat": "Envoyer et entrer sur le chat",
    "Next": "Suivant",
    "Welcome to the Live Chat": "Bienvenue sur ce Live Chat",
    "Please answer our quick survey before joining the chat.": "Avant de commencer, merci de répondre à ces quelques questions.",
    "Your response will not be shared in the chat or with the host.": "Votre réponse ne sera pas rendue publique ou communiquée à l'organisateur du chat.",
    "The Live Chat has ended. You can still ask our Insiders questions on the PathMotion platform.": "Le Live Chat est maintenant terminé. Vous pouvez à tout moment poser vos questions à nos Ambassadeurs directement sur notre app PathMotion.",
    "Sorry, your message is too long.": "Désolé, votre message est trop long.",
    "Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…": "Votre ordinateur semble avoir des problèmes de connectivité. Tentative de reconnexion%{connection_attempt}...",
    "Are you sure you want to delete this discussion?": "Etes-vous sûr(e) de vouloir supprimer cette discussion ?",
    "Are you sure you want to delete this message?": "Etes-vous sûr(e) de vouloir supprimer ce message ?",
    "More Unreads": "Plus de messages non lus",
    "Where do you search for information about a company’s diversity and inclusion policies and initiatives? (Choose top three)": "Où cherchez-vous les informations quant aux initiatives et politiques de diversité d’une entreprise ? (trois choix)",
    "Which of these things would best help indicate that a company genuinely cares about diversity and inclusion? (choose three)": "Parmi ces choix, quels éléments vous aideraient le mieux à cerner l’engagement d’une entreprise envers la diversité et l’inclusion ? (trois choix)",
    "Statistics about representation (e.g. demographic breakdown)": "Des statistiques sur la diversité (ex : le % de femmes aux postes de dirigeants)",
    "Real life stories from employees and their experiences": "Des histoires et expériences authentiques de vrais ambassadeurs",
    "Company information (policies, values, etc.)": "Informations sur l'entreprise (ex : initiatives et valeurs sur le sujet)",
    "Awards won for Diversity & Inclusion": " Les récompenses et prix gagnés pour la diversité et l’inclusion",
    "The types of qualifications being sought during recruitment (e.g. university degrees)": "Les critères de sélection recherchés lors du recrutement (ex : diplômes)",
    "Perceived fairness of recruitment process (e.g. blind applications)": "Equité perçue du processus de recrutement (ex : candidature anonyme)",
    "Specific company initiatives or events (e.g. creation of dedicated D&I work groups)": "Initiatives spécifiques de l’entreprise (ex : création d’un groupe de travail interne dédié à la diversité, partenariats et organisation d’événements en lien avec la diversité etc…)",
    "Emphasis on diversity and inclusion in the office space (e.g. physical accessibility measures)": "L’emphase faite sur la diversité sur le lieu de travail (ex : accès des locaux pour les personnes à mobilité réduite)",
    "Reviews on websites like Glassdoor, FairyGodBoss, etc.": "Des avis de ambassadeurs sur des sites de notation d’entreprises tels que Glassdoor, Indeed, etc.",
    "Details here...": "Précisez…",
    "Awards and rankings sites": "Sites des labels",
    "The company\\'s website": "Le site de l’entreprise",
    "The news or current events reporting": "Les sites d’informations généralistes",
    "Campus fairs and events": "Evénements recrutement (campus, salons emploi etc…)",
    "During interviews": "Lors des entretiens",
    "Social media posts, groups, networks (e.g. Linkedin, Facebook)": "Publications ou groupes sur les réseaux sociaux (Facebook, LinkedIn etc..)",
    "Review websites (e.g. Glassdoor)": "Sites de notation d’entreprise (ex : Glassdoor, Indeed)",
    "Specialist recruitment organisations (e.g. Rare recruitment)": "Organismes de recrutement spécialisés sur le sujet",
    "This isn’t relevant to me": "Cela ne me concerne pas",
    "Ignore": "Ignorer",
    "Previous": "Précédent"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr-FR.po
// module id = 301
// module chunks = 0